export default __webpack_public_path__ + "static/media/whitebit.db7335a7.png";